export default "__VITE_ASSET__C$Kwq7F6__"